import { FC, useMemo } from 'react';
import { useTableData } from './useTableData';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { styled } from '@mui/material';

interface MeshViewerTableProps {
  open: boolean;
}

export const MeshViewerTable: FC<MeshViewerTableProps> = ({ open = true }) => {
  const { data, columns } = useTableData();

  const style = useMemo(() => {
    if (open) {
      return {
        flex: 1,
        width: '300px',
      };
    } else {
      return {};
    }
  }, [open]);

  return (
    <div style={{ ...style }}>
      {open && (
        <StyledDataGrid
          rows={data}
          columns={columns}
          hideFooter
          disableColumnFilter
          disableColumnMenu
          disableColumnReorder={true}
          disableChildrenSorting
          density='compact'
          autosizeOnMount
          autoHeight
        />
      )}
    </div>
  );
};

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
  fontFamily: '"Apercu Pro", sans-serif',
  border: '1px solid rgba(82, 72, 156, 0.1)',
  borderRadius: '12px',
  overflow: 'hidden',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: 'rgba(82, 72, 156, 0.04)',
    borderBottom: '1px solid rgba(82, 72, 156, 0.1)',
    minHeight: '44px !important',
    '& .MuiDataGrid-columnHeader': {
      padding: '12px 16px',
      '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: '13px',
        fontWeight: 600,
        color: theme.palette.text.primary,
        letterSpacing: '0.01em',
      },
    },
    '& .MuiDataGrid-columnSeparator': {
      color: 'rgba(82, 72, 156, 0.1)',
      '&:hover': {
        color: 'rgba(82, 72, 156, 0.3)',
      },
      '& .MuiDataGrid-iconSeparator': {
        color: 'inherit',
      },
    },
  },
  '& .MuiDataGrid-cell': {
    padding: '8px 16px',
    fontSize: '12px',
    borderBottom: '1px solid rgba(82, 72, 156, 0.08)',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-row': {
    '&:hover': {
      backgroundColor: 'rgba(82, 72, 156, 0.02)',
    },
    '&:last-child .MuiDataGrid-cell': {
      borderBottom: 'none',
    },
  },
}));
